import React, { useState } from 'react';
import Avatar from "@mui/material/Avatar";

function AvatarsList({ avatarsList, avatarSelected, handleChooseAvatar }) {


      const handleClick = (url) => {
        handleChooseAvatar(url);
      }
  return (
    <div className="flex flex-cols flex-wrap items-center justify-center gap-5">
        {avatarsList?.map( (avatar, index) => (
        //   <img src={avatar.avatar_url} key={index} alt="" />
            <div  key={index} style={{backgroundColor: avatar?.color}} className={`p-3 md:mx-8 mx-2 rounded-full cursor-pointer ${avatar?.avatar_url === avatarSelected.url ? 'border-blue-4 border-2' : ''}`} value={avatar?.avatar_url} onClick={() => handleClick({url:avatar?.avatar_url,id:avatar?.id})} ><Avatar src={avatar?.avatar_url} imgProps={ {'style':{'objectFit': 'contain'}}} /></div>
            ))}
    </div>
  )
}

export default AvatarsList